import { render, staticRenderFns } from "./DiffItemRenderer.vue?vue&type=template&id=84e85d32&scoped=true"
import script from "./DiffItemRenderer.vue?vue&type=script&lang=js"
export * from "./DiffItemRenderer.vue?vue&type=script&lang=js"
import style0 from "./DiffItemRenderer.vue?vue&type=style&index=0&id=84e85d32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e85d32",
  null
  
)

export default component.exports